import React from "react";
import { Modal } from "semantic-ui-react";
import styled from "styled-components";
import { Constants } from "../Constants";
import BaseComponent from "./BaseComponent";
import PillButton from "./common/PillButton";

const Wrapper = styled.div`
  margin: 20px;
`;

const StyledLI = styled.li`
  padding-bottom: 5px;
`;

const CenteredButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`;

class TestGuideLinesScreen extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      consumer: null,
    };
  }

  render() {
    return (
      <Modal open={this.props.open} style={{ width: "550px" }}>
        <Wrapper>
          <h2>Important Rules on Test Result Files:</h2>

          <ol>
            <StyledLI>
              SafeFun only accepts test results in original PDF format from your
              testing company.
            </StyledLI>
            <StyledLI>
              We do not support faxed results or PDFs generated by Save As or
              printing operations.
            </StyledLI>
          </ol>

          <h3>To submit a test, take the following steps:</h3>

          <ol>
            <StyledLI>
              Save your PDF test result to your phone or tablet's local file
              system.
            </StyledLI>

            <StyledLI>Click Add Test Result from the My Tests screen.</StyledLI>

            <StyledLI>Select the file and submit it.</StyledLI>
          </ol>

          <p>
            For more information on the labs and test results we support, click
            the link below:
          </p>

          <a
            href={Constants.TESTING_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "block", marginBottom: "15px" }}
          >
            {Constants.TESTING_URL}
          </a>

          <p>
            We will scan the file for viruses and fully analyze the file. If we
            recognize the test result format, we will parse the contents and
            perform a match on first name, last name and date of birth. If the
            values all match exactly, the test result will be validated and you
            will have a new Safe Window.
          </p>

          <p>
            If we do not recognize the format, we will automatically add the
            file to our analysis queue to get the format integrated into our
            system. We are committed to supporting every lab that provides
            COVID-19 testing. We appreciate your patience as we work through the
            long list of testing companies.
          </p>

          <CenteredButtonWrapper>
            <PillButton
              primary
              style={{ width: "200px", marginTop: 20 }}
              onClick={() => this.props.closeModal()}
            >
              Got It
            </PillButton>
          </CenteredButtonWrapper>
        </Wrapper>
      </Modal>
    );
  }
}

export default TestGuideLinesScreen;
